import { useMemo } from "react";
import { useCompany } from "./useCompany";
import { useSubscription } from "./useSubscription";

export function useTrialStatus() {
  const { company, loading: companyLoading } = useCompany();
  const { isSubscribed, loading: subLoading } = useSubscription();

  const trialStatus = useMemo(() => {
    if (companyLoading || subLoading) {
      return { isTrialExpired: false, loading: true, hasCompany: false };
    }

    // No company yet — not expired, let them create one
    if (!company) {
      return { isTrialExpired: false, loading: false, hasCompany: false };
    }

    // Has active subscription — never blocked
    if (isSubscribed) {
      return { isTrialExpired: false, loading: false, hasCompany: true };
    }

    // Check trial expiration
    if (!company.trial_ends_at) {
      // No trial date set — treat as expired
      return { isTrialExpired: true, loading: false, hasCompany: true };
    }

    const now = new Date();
    const trialEnd = new Date(company.trial_ends_at);
    const expired = now >= trialEnd;

    return { isTrialExpired: expired, loading: false, hasCompany: true };
  }, [company, companyLoading, isSubscribed, subLoading]);

  return trialStatus;
}
